import React from "react"
import styled from "styled-components"
import Image from "./Image"
import { font } from "../Util/theme"

type Props = {
  icon: string
  label: string
  value: string | null | undefined
}

const DescriptionItem = ({ icon, label, value }: Props) => {
  return (
    <DescriptionItemArea>
      <DescriptionLabel>
        <IconArea>
          <Image filename={icon} />
        </IconArea>
        <Label>{label}</Label>
      </DescriptionLabel>
      <Value>{value}</Value>
    </DescriptionItemArea>
  )
}

const DescriptionItemArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`

const DescriptionLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
`

const IconArea = styled.div`
  width: 22px;
  margin-right: 9px;
`

const Label = styled.div`
  font-size: 16px;
  font-family: ${font.W3};
`

const Value = styled.div`
  font-size: 16px;
  font-weight: 600;
  font-family: ${font.W6};
`

export default DescriptionItem
